import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { tourTypeModification, getSingleTourType } from "./TourTypeAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate, Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { getAllTourType } from "./TourTypeAction";
import { FaArrowLeft } from 'react-icons/fa';


const initialState = {
  id: "",
  tour: "",
  status: "",

}



const ModifyTourType = () => {
  let navigate = useNavigate();
    const {id}=useParams();

    const { stismloading, stmstatus, stmmessage  } = useSelector((state) => state.tourTypesList);

    const dispatch = useDispatch();
    
    const [tours, settours] = useState({
      id:"",
      tour:"",
      status:""
    });
    
 
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);

    const tourTypeData = useSelector((state) => state.tourTypesList);



    const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadTourType(id);
      return;
    }

  });
   useEffect(() => { 
    console.log('useEffect');
    loadTourType(id);
    settours({id:id,tour:'',status:''});
   
     }, []);
     
     useEffect(() => {
      dispatch(getAllTourType());
     
  }, [dispatch,stmmessage]);
     
     
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   

    function loadTourType(id){
    
      dispatch(getSingleTourType(id));
      settours({id:id,tour:uData.reservation_tour,status:uData.status});
   }

  
   const uData = JSON.parse(JSON.stringify(tourTypeData.stSDetails));
 
  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    settours({ ...tours, [name]: value });
   
  };
 

  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    const { id, tour, status
    } = tours;

    if (tour === "" && status === "") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/tourtypesList');
      return;
    }

    const tourUpdation1 = {
      id,
      tour,
      status
    };
   
    dispatch(tourTypeModification(tourUpdation1));
    setModify(1);
    Swal.fire({
      title: 'Success!',
      text: 'Tour Type Details Updated Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })
    navigate('/tourtypesList');
  
  };



  return (
    <>
     
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Tour Type</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/tourtypesList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Tour Type</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                 <Form.Control type="text"  name="tour" value={tours.tour ? tours.tour : uData.tour_type} autoComplete='off' placeholder="Enter Tour Type" {...register("tour", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                </Form.Group>
               
              
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={tours.status ? tours.status : uData.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
              <FontAwesomeIcon icon={faRightToBracket} /> Update
              </Button>
              </div>
            
            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default ModifyTourType;